import { jsx, jsxs } from 'react/jsx-runtime';
import { cx } from 'class-variance-authority';
import { navigationBarItemContainerStyles, navigationBarItemStyles, navigationBarIconContainer, navigationBarIconInnerContainer } from '../NavigationBarItem/navigation-bar-item-styles.js';
import { useNavigationContext } from '../NavigationContext/NavigationContext.js';

/**
 * Component to be passed as children to `NavigationDisclosureItem`
 *
 * @example
 * return (
 *  <NavigationDisclosureItem
 *   listItems={(
 *     <>
 *       <NavigationDisclosureListItem label="Home" as="a" href="/home" />
 *       <NavigationDisclosureListItem label="Search" as="a" href="/search" />
 *     </>
 *   )}
 * )
 */
const NavigationDisclosureListItem = ({ as, label, ...props }) => {
    const Component = as || "div";
    const { isExpanded } = useNavigationContext();
    return (jsx("li", { className: cx(navigationBarItemContainerStyles()), children: jsxs(Component, { className: cx(navigationBarItemStyles({
                bold: false,
            }), "mci-px-xs"), ...props, children: [isExpanded && (jsx("div", { className: cx(navigationBarIconContainer(), "xs:mci-hidden md:mci-block"), children: jsx("div", { className: navigationBarIconInnerContainer() }) })), jsx("div", { className: "mci-text-body-small", children: label })] }) }));
};

export { NavigationDisclosureListItem };
